var render, staticRenderFns
import script from "./MoreData.vue?vue&type=script&lang=js&"
export * from "./MoreData.vue?vue&type=script&lang=js&"
import style0 from "./MoreData.vue?vue&type=style&index=0&id=4c8a95a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a95a1",
  null
  
)

export default component.exports